var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('b-card',[_c('b-card-header',[_vm._v("Restaurant Payout Analytics")]),_c('b-card-body',{key:_vm.key},[_c('iframe',{staticStyle:{"min-height":"100vh"},attrs:{"src":_vm.iframe_url,"frameborder":"0","width":"100%","height":"100%","allowtransparency":""}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }